<template>
  <fragment>
    <mc-app-header title="Add DailyChallenge">
      <template #right>
        <div class="level-item">
          <b-button
            :loading="
              dailyChallenges.submitting || dailyChallenges.typeformInfoLoading
            "
            :disabled="
              !(
                dailyChallenges.typeformInfo &&
                dailyChallenges.typeformInfo.hidden.includes('user_id')
              )
            "
            type="is-primary"
            form="newDailyChallengeForm"
            native-type="submit"
            >Add</b-button
          >
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="add-challenge section">
        <form
          id="newDailyChallengeForm"
          class="mc-container"
          @submit.prevent="addDailyChallengeHandler"
        >
          <b-field label="Typeform Url">
            <typeform-input
              v-model="newDailyChallenge.typeformId"
              @input="getTypeformInfoHandler"
            />
          </b-field>
          <b-loading
            v-if="dailyChallenges.typeformInfoLoading"
            active
            :is-full-page="false"
          />
          <div v-else-if="!dailyChallenges.typeformInfo">
            <b-message type="is-info" has-icon>
              Please enter a valid typeform URL to see the rest of the form.
            </b-message>
          </div>
          <div v-else>
            <b-field label="Names">
              <b-input v-model="dailyChallenges.typeformInfo.title" disabled>
              </b-input>
            </b-field>
            <b-field label="Date of the DailyChallenge">
              <mc-date-time
                v-model="newDailyChallenge.date"
                placeholder="Click to select..."
                required
              >
              </mc-date-time>
            </b-field>
            <b-field label="Challenge Question:">
              <b-select
                v-model="newDailyChallenge.typeformQuestionId"
                placeholder="Select the Question"
                expanded
                required
              >
                <option
                  v-for="(option, index) in dailyChallenges.typeformInfo.fields"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ index + 1 }}. {{ option.title }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-if="!!newDailyChallenge.typeformQuestionId"
              label="Correct option for that question"
            >
              <b-select
                v-model="newDailyChallenge.typeformQuestionAnswerLabel"
                placeholder="Select the Currect Option"
                required
                expanded
                :disabled="!newDailyChallenge.typeformQuestionId"
              >
                <option
                  v-for="option in getTypeformQuestion(
                    newDailyChallenge.typeformQuestionId
                  ).properties.choices"
                  :key="option.id"
                  expanded
                  :value="option.label"
                >
                  {{ option.label }}
                </option>
              </b-select>
            </b-field>
          </div>
        </form>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import TypeformInput from './TypeformInput';

export default {
  data() {
    return {
      newDailyChallenge: {
        typeformId: null,
        date: null,
        typeformQuestionId: null,
        typeformQuestionAnswerLabel: null
      }
    };
  },
  computed: {
    ...mapState(['dailyChallenges'])
  },
  methods: {
    ...mapActions('dailyChallenges', ['getTypeformInfo', 'addDailyChallenge']),
    getTypeformQuestion(questionId) {
      return this.dailyChallenges.typeformInfo.fields.find(
        field => field.id === questionId
      );
    },
    async addDailyChallengeHandler() {
      try {
        await this.addDailyChallenge({
          name: this.dailyChallenges.typeformInfo.title,
          ...this.newDailyChallenge
        });
        this.$buefy.toast.open({
          message: 'Daily Challenge created!!',
          type: 'is-success'
        });
        this.$router.replace('/daily_challenges');
      } catch (error) {
        this.$buefy.toast.open({
          message: error.message,
          type: 'is-danger'
        });
      }
    },
    async getTypeformInfoHandler(formId) {
      try {
        await this.getTypeformInfo(formId);
      } catch (error) {
        this.$buefy.toast.open({
          message: error,
          type: 'is-danger'
        });
      }
    }
  },
  created() {
    this.getTypeformInfo();
  },
  components: {
    TypeformInput
  }
};
</script>

<style></style>
